export default "__VITE_ASSET__Btj_yvx6__"